<template>
  <v-form ref="form" v-model="valid">
    <v-card class="pa-3">
      <v-card-text>
        <v-select
          v-model="formData.type"
          :items="types"
          :label="$t('common.Type')"
          required
          :rules="mandatoryRule"
        />

        <v-select
          v-if="formData.type == 1"
          v-model="formData.subType"
          :items="subTypes"
          :label="$t('common.SubType')"
          required
          :rules="mandatoryRule"
        />

        <v-select
          v-if="formData.type == 1 && formData.subType == 3"
          v-model="formData.practicalSubType"
          :items="praticalSubTypes"
          :label="$t('common.PracticalSubType')"
          required
          :rules="mandatoryRule"
        />

        <v-select
          :rules="mandatoryRule"
          v-model="formData.where"
          :items="whereItems"
          :label="$t('common.Where')"
        />

        <v-text-field
          v-model="formData.title"
          :label="$t('common.Title')"
          required
          :rules="mandatoryRule"
        />
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="formData.date"
              :label="$t('common.Date')"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="formData.date" @input="menu2 = false"></v-date-picker>
        </v-menu>
        <v-text-field
          v-model="formData.local"
          :label="$t('common.Local')"
          required
          :rules="mandatoryRule"
        />
        <v-text-field
          v-model="formData.organizer"
          :label="$t('common.Organizer')"
          required
          :rules="mandatoryRule"
        />
        <v-select
          v-if="!isLinking"
          :disabled="!canCreateScientificActivity"
          item-text="title"
          item-value="id"
          v-model="formData.linkedScientificActivityId"
          :items="scientificActivities"
          :label="$t('common.ScientificActivity')"
        />
        <v-flex xs6 v-if="canCreateScientificActivity && !isLinking">
          <v-btn @click="scientitficActivityDialog = true" small color="primary" dark>
            <v-icon>add</v-icon>
            {{$t('courses.LinkNewScientificActivity')}}
          </v-btn>
        </v-flex>

        <v-flex xs12>
          <file-upload
            :file-url-uploaded="formData.fileUrlAttached || ''"
            :file-name-uploaded="formData.fileNameAttached || ''"
            @fileRemoved="fileRemoved"
            @uploadComplete="fileAdded"
            :path-to-files="filepath"
          ></file-upload>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :loading="loading"
          color="success"
          @click="submit"
          :disabled="!valid"
        >{{$t('common.Submit')}}</v-btn>
        <v-btn flat color="gray" @click="closeMe">{{$t('common.Cancel')}}</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog :persistent="true" v-model="scientitficActivityDialog" max-width="600" lazy>
      <AddEntryForm
        :is-linking="true"
        :after-submit="afterCreateScientificActivity"
        :form-data="newScientificActivity"
        :close-me="() => scientitficActivityDialog = false"
      />
    </v-dialog>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import cms from "@/content";
import AddEntryForm from "@/views/ScientificAcitivity/AddEntryForm";
import FileUpload from "@/components/files/FileUpload";

export default {
  name: "AddCourseForm",
  components: {
    'AddEntryForm': AddEntryForm,
    FileUpload
  },
  props: {
    afterSubmit: {
      required: false,
      type: Function
    },
    closeMe: {
      required: true,
      type: Function
    },
    formData: {
      type: Object
    },
    isLinking: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newScientificActivity: { type: 2, autonomy: 1 },
      scientitficActivityDialog: false,
      menu2: false,
      valid: false,
      loading: false,
      canCreateScientificActivity: true
    };
  },
  computed: {
    ...mapGetters(["scientificActivities", "user"]),
    filepath(){
      return `${this.$store.getters.profile.id}/courses`
    },
    userIsOphthalmology() {
      return this.user.specialty === "ophthalmology";
    },
    mandatoryRule() {
      return [v => !!v || this.$t("common.RequiredField")];
    },
    types() {
      return cms.getCourseTypes(this.$i18n.locale);
    },
    subTypes() {
      return cms.getCourseSubTypes(this.$i18n.locale);
    },
    praticalSubTypes() {
      if (this.userIsOphthalmology) {
        return cms.getCoursePracticalSubTypesOphthamology(this.$i18n.locale);
      } else {
        return cms.getCoursePracticalSubTypes(this.$i18n.locale);
      }
    },
    whereItems() {
      return cms.getScopesPresentationType(this.$i18n.locale);
    }
  },
  methods: {
    ...mapActions([
      "addCourse",
      "updateCourse",
      "showSuccessSnackbar",
      "getScientificActivities"
    ]),
    fileRemoved() {
      this.formData.fileUrlAttached = "";
      this.formData.fileNameAttached = "";
    },
    fileAdded(fileUrl, fileName) {
      this.formData.fileUrlAttached = fileUrl;
      this.formData.fileNameAttached = fileName;
    },
    afterCreateScientificActivity() {
      this.formData.linkedScientificActivityId = this.scientificActivities[
        this.scientificActivities.length - 1
      ].id;
      this.canCreateScientificActivity = false;
    },
    submit() {
      this.loading = true;

      if (!this.formData.id) {
        this.formData.userId = this.$store.getters.profile.id;
      }

      let action =
        this.formData && this.formData.id
          ? this.updateCourse({ id: this.formData.id, ...this.formData })
          : this.addCourse({ ...this.formData });

      action.then(() => {
        this.closeMe();

        if (this.formData && this.formData.id) {
          this.showSuccessSnackbar(this.$t("courses.CourseUpdated"));
        } else {
          this.showSuccessSnackbar(this.$t("courses.CourseCreated"));
        }

        if (this.afterSubmit) {
          this.afterSubmit(this.formData);
        }

        this.$refs.form.reset();
        this.loading = false;
      });
    }
  }
};
</script>
